import React, { useState } from "react"; // Added React and useState
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { eventService } from "../lib/api/event";
import Swal from "sweetalert2";
import { routes } from "../routes/routes-names";
import { useNavigate } from "react-router-dom";
//@ts-ignore
import Files from 'react-files';
import { ReactFilesFile } from '../types/files';
import { isLessThanTheMB } from '../lib/utils/lessthan-max-filesize';
import { Messages } from '../lib/constants/messages';
import "../assets/styles/organisation-registration.css";
// Note: Ensure these components/helpers exist in your project
// import Files from "react-files"; 

const schema = Yup.object({
  organizationName: Yup.string().required("Required"),
  eventType: Yup.string().required("Required"),
  department: Yup.string().required("Required"),
  topic: Yup.string().required("Required"),
  startDate: Yup.date().required("Required"),
  endDate: Yup.date().min(Yup.ref("startDate"), "End date must be after start date").required("Required"),
  creditHours: Yup.number().min(0).required("Required"),
  venue: Yup.string().required("Required"),
  programsheet1: Yup.mixed().required("Program sheet is required") // Added to schema
});

export default function UpcomingEventsForm() {

  const navigate = useNavigate();
  // Local state for file preview/management
  const [programsheet1File, setProgramsheet1File] = useState<{ file?: File; error?: string } | null>(null);

  // Helper for file size (500KB = 512000 bytes)
  const isLessThanTheMB = (size: any, mb: any) => size <= mb * 1024 * 1024;

  return (
    <div className="glass-page event-page">
      <div className="form-card" style={{ width: "100%", maxWidth: 1280 }}>
        <h2 style={{ textAlign: "center", marginBottom: 18, fontWeight: 700 }}>
          Update Upcoming Events
        </h2>
          <Formik
            initialValues={{
              organizationName: "",
              eventType: "",
              department: "",
              topic: "",
              startDate: "",
              endDate: "",
              creditHours: "",
              venue: "",
              programsheet1: null // Added to initial values
            }}
            validationSchema={schema}
            onSubmit={async (values) => {
              try {
                const upcomingInfo = {
                  ...values,
                };
                const formData = new FormData();
                formData.append("upcomingInfo", JSON.stringify(upcomingInfo));
                if (programsheet1File?.file) {
                  formData.append("programSheet1", programsheet1File?.file);
                }
                await eventService.saveUpComingEvents(formData);

                  Swal.fire({
                    title: "",
                    text: "Upcoming Event updated successfully",
                    icon: "success",
                    confirmButtonText: "OK",
                  }).then(async (result) => {
                  });
                navigate(routes.adminLayout);
              } catch (error) {
                Swal.fire({
                    title: "",
                    text: "Error in saving Event update",
                    icon: "error",
                    confirmButtonText: "OK",
                  }).then(async (result) => {
                  });
              }
            }}
          >
            {/* 1. Added Render Props here to access Formik state */}
            {({ values, errors, touched, setFieldValue }) => (
              <Form>
                <div className="row g-3">
                  <div className="col-md-4">
                    <label className="org-info-item">Organization Name</label>
                    <Field name="organizationName" className="soft-input" />
                  {errors.organizationName && touched.organizationName && <div className="text-danger">{errors.organizationName}</div>}
                  </div>

                  <div className="col-md-4">
                    <label className="org-info-item">Event Type</label>
                    <Field name="eventType" className="soft-input" />
                  </div>

                  <div className="col-md-4">
                    <label className="org-info-item">Department</label>
                    <Field name="department" className="soft-input" />
                  </div>

                  <div className="col-md-4">
                    <label className="org-info-item">Topic</label>
                    <Field name="topic" className="soft-input" />
                  </div>

                  <div className="col-md-4">
                    <label className="org-info-item">Start Date</label>
                    <Field type="date" name="startDate" className="soft-input" />
                  </div>

                  <div className="col-md-4">
                    <label className="org-info-item">End Date</label>
                    <Field type="date" name="endDate" className="soft-input" />
                  </div>

                  <div className="col-md-4">
                    <label className="org-info-item">Credit Hours</label>
                    <Field name="creditHours" type="number" className="soft-input" />
                  </div>

                  <div className="col-md-4">
                    <label className="org-info-item">Venue</label>
                    <Field name="venue" className="soft-input" />
                  </div>
                </div>

                <div className="row mb-2 mt-4">
                  <div className='text-danger fs-10'>
                    Please upload images/pdfs (.jpeg, .png, .pdf) only, less than 500 KB.
                  </div>
                </div>

                <div className="row mb-2 mt-4 align-items-center justify-content-center">
                                    <div className="col-4 mt-3">
                                      <div className="drag-img-box d-flex align-items-center justify-content-center">
                                        {values.programsheet1 ? <>
                                          <div className="text-center">
                                            <p className="text-success">Uploaded: {programsheet1File?.file?.name}</p>
                                            <button
                                              type="button"
                                              className="btn btn-sm btn-danger"
                                              onClick={() => {
                                                setProgramsheet1File(null);
                                                setFieldValue("programsheet1", null);
                                              }
                                              }
                                            >
                                              <i className="bi bi-trash"></i>
                                            </button>
                                          </div>
                                        </> : <>
                                          <Files
                                            className="files-dropzone border p-3"
                                            onChange={(files: ReactFilesFile[]) => {
                                              if (files[0]) {
                                                const file = files[0];
                                                const isLess = isLessThanTheMB(files[0].size, 0.5);
                                                if (isLess) {
                                                  setProgramsheet1File({ file });
                                                  setFieldValue("programsheet1", file.name);
                                                }
                                                else {
                                                  alert(Messages.isLessThanTheMB);
                                                }
                                              }
                                            }}
                                            accepts={["application/pdf", "image/*"]}
                                            maxFiles={1}
                                            clickable
                                          >
                                            <div className="text-center">
                                              <i className="bi bi-file-earmark-arrow-up"></i>
                                              <p>
                                                Brochure:<span className="text-danger">*</span> </p>
                                            </div>
                                          </Files>
                                        </>}
                                        {errors.programsheet1 && touched.programsheet1 && (
                                          <div className="text-danger">{errors.programsheet1}</div>
                                        )}
                                      </div>
                                    </div>
                </div>

                <div className="d-flex justify-content-end mt-3">
                  <button type="submit" className="primary-btn">Save Event</button>
                </div>
              </Form>
            )}
          </Formik>
      </div>
    </div>

  );
}
